import * as yup from "yup";
import { getStringRequiredFieldMessage } from "@shared/utils/yup-extensions";

export const startMlsSubscriptionFlowFormSchema = yup
  .object({
    partner: yup
      .string()
      .trim()
      .min(1, getStringRequiredFieldMessage)
      .required()
      .label("Membership Affiliation"),
  })
  .required();

export type StartMlsSubscriptionFlowSchema =
  typeof startMlsSubscriptionFlowFormSchema.__outputType;
